module.exports = __webpack_public_path__ + "static/media/Matador.81e325be.svg";